import Bacon from 'baconjs';
import $ from 'jquery';
import { isValidEmail, isValidPhoneNumber, isValidZip } from 'scripts/tools/validation';
import * as receiptCard from './aktiv-receipt';
import * as TagManager from 'scripts/components/analytics/tagManagerApi';

const validationRules = [
    {
        inputGroupSelector: '#aktivContactInputGroupPhoneEmail',
        inputSelector: '#aktivContactInputPhoneEmail',
        rulePredicate: value => value && (isValidEmail(value) || isValidPhoneNumber(value)),
    },
    {
        inputGroupSelector: '#aktivContactInputGroupZip',
        inputSelector: '#aktivContactInputZip',
        rulePredicate: value => value && isValidZip(value),
    },
    {
        inputGroupSelector: '#aktivContactInputGroupName',
        inputSelector: '#aktivContactInputName',
        rulePredicate: value => value !== '',
    },
    {
        inputGroupSelector: '#aktivContactInputGroupAddress',
        inputSelector: '#aktivContactInputAddress',
        rulePredicate: value => value !== '',
    },
];

const setValidationState = ($element, isValid) => {
    if (isValid) {
        $element.addClass('has-success');
        $element.removeClass('has-error');
    } else {
        $element.addClass('has-error');
        $($element).removeClass('has-success');
    }
};

const validationStreamFactory = (validationRule) => {
    Bacon.fromEvent($(validationRule.inputSelector), 'change')
        .map(e => validationRule.rulePredicate(e.target.value))
        .skipDuplicates()
        .onValue(result => {
            // Update validation rule with the validation result
            validationRule.isValid = result;
            // Update state in GUI
            setValidationState($(validationRule.inputGroupSelector), validationRule.isValid);
        });
};

const postContactForm = () => {
    const emailOrPhone = $('#aktivContactInputPhoneEmail').val();

    return $.post('/api/aktivcontact/contactform', {
        name: $('#aktivContactInputName').val(),
        address: $('#aktivContactInputAddress').val(),
        zip: $('#aktivContactInputZip').val(),
        email: isValidEmail(emailOrPhone) ? emailOrPhone : '',
        phone: isValidPhoneNumber(emailOrPhone) ? emailOrPhone : '',
        brokerOfficeId: $('#aktivBrokerOfficeId').val(),
        brokerId: $('#aktivBrokerId').val(),
        taskTemplateId: $('#aktivTaskTemplateId').val(),
        concentType: $('#concentType').val()
    });
};

const pushToTagManager = (metadata, postalCode) => {
    if (metadata.officeId) {
        TagManager.push({
            'event': metadata.event,
            'officeName': metadata.officeName,
            'officeId': metadata.officeId,
            'zipNumber': postalCode,
        });
    } else {
        TagManager.push({
            'event': metadata.event,
            'zipNumber': postalCode,
        });
    }
};

export const init = (options) => {
    validationRules.map(validationStreamFactory);
    const $button = $('#aktivContactButtonSend');
    const $errorMsg = $('#aktivContactErrorMsg');
    const $contactCard = $('#aktivContactCard');
    const buttonText = $button.text();
    const buttonBusyText = $button.attr('data-busy-text');
    
    $contactCard.on('submit', 'form', (event) => {
        event.preventDefault();
        // Trigger change to re-validate inputs
        for (const rule of validationRules) {
            $(`${rule.inputGroupSelector} input`).change();
        }
        const isAllValid = validationRules.every(r => r.isValid);

        if (isAllValid) {
            $button.attr('disabled', 'disabled');
            $button.text(buttonBusyText);
            $errorMsg.hide();

            postContactForm(options).then(result => {
                const postalCode = $('#aktivContactInputZip').val();
                pushToTagManager(options.tagManagerMetaData, postalCode);
                $contactCard.hide();
                receiptCard.init({
                    name: $('#aktivContactInputName').val(),
                    eaTaskId: result.eaTaskId,
                    tagManagerMetaData: options.tagManagerMetaDataForReceiptForm,
                    goalId: options.receiptGoalId
                });
            }, () => {
                $errorMsg.show();
            }).always(() => {
                $button.removeAttr('disabled');
                $button.text(buttonText);
            });
        }
    });
};
